import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)


// WEBPACK FOOTER //
// ./src/library/mint.js